import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ISalesInvoiceReportGetAllParams } from "@api/stores/salesInvoiceReport/types";

import type { IPathBaseParam } from "./path";
import type { ISalesInvoiceReportStatsResponse } from "./types";

const getApis = createGetApi<
  IApiResponse<ISalesInvoiceReportStatsResponse>,
  IPathBaseParam,
  ISalesInvoiceReportGetAllParams
>("stores.salesInvoiceReport.stats");

export const stats = {
  ...getApis,
};
